/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespEditorialModuleItem_item = {
    readonly description: string | null;
    readonly cta: string | null;
    readonly imageUrl: string | null;
    readonly imageWidth: string | null;
    readonly imageHeight: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData">;
    };
    readonly " $refType": "HpRespEditorialModuleItem_item";
};
export type HpRespEditorialModuleItem_item$data = HpRespEditorialModuleItem_item;
export type HpRespEditorialModuleItem_item$key = {
    readonly " $data"?: HpRespEditorialModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModuleItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespEditorialModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageWidth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EditorialItem",
  "abstractKey": null
};
(node as any).hash = '71e55e56906ee186d6f7b6b66801a2be';
export default node;
